import React, { FC, useState } from 'react'
import BottomSheet from '@components/BottomSheet'
import { Stack, Switch, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useActivitySettings } from '@plug-core/state'
import { TransactionKind } from '@plug-core/clients/LedgerScannerClient'
import Touchable from '@components/Touchable'
import { VscSettings } from 'react-icons/vsc'

const TransactionFilter: FC = () => {
  const { t } = useTranslation()

  const { activityTypes, addActivityType, removeActivityType } = useActivitySettings()

  const [filtersVisible, setFiltersVisible] = useState(false)

  return (
    <>
      <Touchable onClick={() => setFiltersVisible(true)}>
        <Stack
          bgcolor={(theme) => theme.palette.background.paper}
          height={40}
          width={40}
          justifyContent="center"
          alignItems="center"
          borderRadius={1}
        >
          <VscSettings size={20} />
        </Stack>
      </Touchable>

      <BottomSheet visible={filtersVisible} onBackdropClick={() => setFiltersVisible(false)}>
        <Stack py={2}>
          <Typography variant="h6" textAlign="center" fontWeight={600}>
            {t('transactionHistory.filter')}
          </Typography>

          <Stack spacing={0.5} mx={2.5} mt={2}>
            {[
              TransactionKind.Transfer,
              TransactionKind.Burn,
              TransactionKind.Mint,
              TransactionKind.Approve,
            ].map((activity) => (
              <Stack key={activity} direction="row" alignItems="center">
                <Typography flex={1}>{t(`transactionHistory.filters.${activity}`)}</Typography>
                <Switch
                  checked={activityTypes.includes(activity)}
                  onChange={(_, checked) =>
                    checked ? addActivityType(activity) : removeActivityType(activity)
                  }
                  color="success"
                />
              </Stack>
            ))}
          </Stack>
        </Stack>
      </BottomSheet>
    </>
  )
}

export default TransactionFilter
